import React, { FC } from 'react'
import styles from './CuratedDeals.module.scss'
import ListConnector, { ConnectorProps as ListProps } from '../connectors/List'

const Disclaimer: FC<ListProps> = ({ promoCode }) => {
  return (
    <div className={styles.disclaimerWrapper}>
      <div className={styles.disclaimer}>
        <p className={styles.text}>
          Promotional offer <span>{promoCode}</span> for recurring Curated Deals is valid on each
          week’s select original artworks and excludes open edition and limited edition prints.
          Cannot be applied to commissioned works, nor combined with otherwise negotiated prices.
          Cannot be applied to previous orders.
        </p>
      </div>
    </div>
  )
}

export default ListConnector(Disclaimer)
